// extracted by mini-css-extract-plugin
module.exports = {"th":"Table_th__3Zo_Y","tbody":"Table_tbody__3-Um1","recentReview":"Table_recentReview__27nPh"};